module.exports = __webpack_public_path__ + "img/garageservices1.e7e88bb5.jpg";